export default __webpack_public_path__ + "assets/audios/d7244da6833c752796bd0a5b0b53b82a.wav";